// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
// 連絡帳のみ
// const awsmobile =  {
//   Auth: {
//         identityPoolId: 'ap-northeast-1:ff8e666c-ffef-45e1-a4df-8a795ad1cf3b',
//         region: 'ap-northeast-1',
//         userPoolId: 'ap-northeast-1_97lek9fyN',
//         userPoolWebClientId: '2p4s9f7lg4hda7bbb6kvmng602',
//     },
//     "aws_appsync_graphqlEndpoint": "https://47a4tt4afzgtxe4ghdzrsg47hi.appsync-api.ap-northeast-1.amazonaws.com/graphql",
//     "aws_appsync_region": "ap-northeast-1",
//     "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
//     "aws_appsync_apiKey": "da2-t6occdet2rbuffibbyzl43jzl4",
// }
// export default awsmobile

// 管理者と連絡帳
// const awsmobile =  {
//   Auth: {
//         identityPoolId: 'ap-northeast-1:70a06385-941b-4fa1-95f7-02a88d216921',
//         region: 'ap-northeast-1',
//         userPoolId: 'ap-northeast-1_SU5dg35On',
//         userPoolWebClientId: '75e3engdjcddeu5c9b697mftr6',
//     },
//     "aws_appsync_graphqlEndpoint": "https://tonkoj4rnrhojbreb7dudi3yi4.appsync-api.ap-northeast-1.amazonaws.com/graphql",
//     "aws_appsync_region": "ap-northeast-1",
//     "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
//     "aws_appsync_apiKey": "da2-3pbv6dqc5jaexdfvboovwo7jsq",
// }
// export default awsmobile

/* eslint-disable */
const hostname = location.hostname
const env = hostname.split('.')[0]
function createAwsmobile() {
  if (env === 'local' || env === 'localhost' || env === 'qa1') {
    // ーーーーーーQA・local環境ーーーーーーー
    return {
      Auth: {
        "identityPoolId": "ap-northeast-1:70a06385-941b-4fa1-95f7-02a88d216921",
        "region": "ap-northeast-1",
        "userPoolId": "ap-northeast-1_SU5dg35On",
        "userPoolWebClientId": "75e3engdjcddeu5c9b697mftr6",
      },
      "aws_appsync_graphqlEndpoint": "https://jbjjpavsqrdqbhcmboalvcyz5q.appsync-api.ap-northeast-1.amazonaws.com/graphql",
      "aws_appsync_region": "ap-northeast-1",
      "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
      "aws_appsync_apiKey": "da2-3pbv6dqc5jaexdfvboovwo7jsq",
    }
  } else if (env === 'ccsapp') {
    // ーーーーーー本番環境ーーーーーーー
    return {
      Auth: {
        "identityPoolId": "ap-northeast-1:ff8e666c-ffef-45e1-a4df-8a795ad1cf3b",
        "region": "ap-northeast-1",
        "userPoolId": "ap-northeast-1_97lek9fyN",
        "userPoolWebClientId": "2p4s9f7lg4hda7bbb6kvmng602",
      },
      "aws_appsync_graphqlEndpoint": "https://eoewmbmmhfgqzexa3d7l7z4cn4.appsync-api.ap-northeast-1.amazonaws.com/graphql",
      "aws_appsync_region": "ap-northeast-1",
      "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
      "aws_appsync_apiKey": "da2-t6occdet2rbuffibbyzl43jzl4",
    }
  }
}
const awsmobile = createAwsmobile()
export default awsmobile;



// WEBPACK FOOTER //
// ./src/.config/aws-exports.js